<template>
	<a-layout :class="['layout', device]">
		<!-- SideMenu -->
		<a-drawer
			v-if="isMobile()"
			placement="left"
			:wrapClassName="`drawer-sider ${navTheme}`"
			:closable="false"
			:visible="collapsed"
			@close="drawerClose"
		>
			<side-menu
				mode="inline"
				:menus="menus"
				:theme="navTheme"
				:collapsed="false"
				:collapsible="true"
				@menuSelect="menuSelect"
			></side-menu>
		</a-drawer>

		<side-menu
			v-else-if="isSideMenu()"
			mode="inline"
			:menus="menus"
			:theme="navTheme"
			:collapsed="collapsed"
			:collapsible="true"
		></side-menu>

		<a-layout
			:class="[layoutMode, `content-width-${contentWidth}`]"
			:style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh' }"
		>
			<!-- layout header -->
			<global-header
				:mode="layoutMode"
				:menus="menus"
				:theme="navTheme"
				:collapsed="collapsed"
				:device="device"
				@toggle="toggle"
			/>

			<!-- layout content -->
			<a-layout-content
				:style="{
					height: '100%',
					margin: '24px 24px 0',
					paddingTop: fixedHeader ? '64px' : '0',
				}"
			>
				<multi-tab v-if="multiTab"></multi-tab>
				<!--<transition name="fade-transverse">-->
				<route-view />
				<audio-player></audio-player>
				<!--</transition>-->
			</a-layout-content>

			<!-- layout footer -->
			<!--<a-layout-footer>-->
			<!--<global-footer />-->
			<!--</a-layout-footer>-->
		</a-layout>
	</a-layout>
</template>

<script>
import { triggerWindowResizeEvent } from '@/utils/util'
import { mapState, mapActions } from 'vuex'
import { mixin, mixinDevice } from '@/utils/mixin'

import RouteView from './RouteView.vue'
import SideMenu from '@/components/menu/SideMenu.vue'
import GlobalHeader from '@/components/page/GlobalHeader.vue'
// import GlobalFooter from '@/components/page/GlobalFooter.vue'
import AudioPlayer from '@/components/AudioPlayer/AudioPlayer.vue'

export default {
	name: 'BasicLayout',
	mixins: [mixin, mixinDevice],
	components: {
		RouteView,
		SideMenu,
		GlobalHeader,
		AudioPlayer,
		// GlobalFooter,
	},
	data() {
		return {
			collapsed: false,
			menus: [],
		}
	},
	computed: {
		...mapState({
			// 动态主路由
			mainMenu: state => state.permission.addRouters,
		}),
		contentPaddingLeft() {
			if (!this.fixSidebar || this.isMobile()) {
				return '0'
			}
			if (this.sidebarOpened) {
				return '216px'
			}
			return '80px'
		},
	},
	watch: {
		sidebarOpened(val) {
			this.collapsed = !val
		},
	},
	created() {
		this.menus = this.mainMenu.find(item => item.path === '/').children
		this.collapsed = !this.sidebarOpened
	},
	mounted() {
		const userAgent = navigator.userAgent
		if (userAgent.indexOf('Edge') > -1) {
			this.$nextTick(() => {
				this.collapsed = !this.collapsed
				setTimeout(() => {
					this.collapsed = !this.collapsed
				}, 16)
			})
		}
	},
	methods: {
		...mapActions('app', ['setSidebar']),
		toggle() {
			this.collapsed = !this.collapsed
			this.setSidebar(!this.collapsed)
			triggerWindowResizeEvent()
		},
		paddingCalc() {
			let left = ''
			if (this.sidebarOpened) {
				left = this.isDesktop() ? '216px' : '80px'
			} else {
				left = (this.isMobile() && '0') || (this.fixSidebar && '80px') || '0'
			}
			return left
		},
		menuSelect() {},
		drawerClose() {
			this.collapsed = false
		},
	},
}
</script>

<style lang="less">
@import url('~@/styles/ant-pro/global.less');

.fade-transverse-leave-active,
.fade-transverse-enter-active {
	transition: all 0.5s;
}
.fade-transverse-enter {
	opacity: 0;
	transform: translateX(-30px);
}
.fade-transverse-leave-to {
	opacity: 0;
	transform: translateX(30px);
}
</style>
